import React, { useEffect, useState } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import TextField from '../common/Input';
import Button from '../common/Button';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormValidator from '../../utils/validator';
import { toast } from 'react-toastify';
import { categoryadd, registersubcategory } from '../../actions/category';
import { getcategorieslist } from '../../actions/category';

const AddCategory = props => {
  const { classes } = props;
  const [errors, setErrors] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [category, setCategory] = useState({
    categoryName: ''
  });
  const schema = [
    {
      field: 'categoryName',
      method: ['isEmpty'],
      validWhen: false,
      message: 'Category is required.'
    }
  ];
  const validator = new FormValidator(schema);
  const handleChange = (key, e) => {
    setCategory({
      ...category,
      [key]: e.target.value
    });
  };

  const addCategory = () => {
    const err = validator.validate({ ...category });
    setErrors(err);
    if (!err.isValid) {
      return;
    }
    setLoading(true);
    categoryadd(category, (message, isError) => {
      const method = isError ? 'error' : 'success';
      toast[method](message);
      setLoading(false);
      // setCategory({ categoryName: "" });
      //window.location.reload();
      // if (method === 'success') {
      // setTableKey(tableKey + 1);
      //window.location.reload();
      // }
    });
  };
  return (
    <div>
      <Card className={classes.root}>
        <CardHeader
          subheader="Add Category"
          classes={{ subheader: classes.header }}
        />
        <CardContent>
          <TextField
            label="Category Name"
            name="categoryName"
            placeholder="Add Category name"
            onChange={e => handleChange('categoryName', e)}
            classes={{ root: classes.input }}
            value={category.categoryName}
            error={
              errors && errors.categoryName && errors.categoryName.isInvalid
            }
            helperText={
              errors &&
              errors.categoryName &&
              errors.categoryName.isInvalid &&
              errors.categoryName.message
            }
          />
          <Button size="small" label="Add" onClick={addCategory}></Button>
        </CardContent>
      </Card>
    </div>
  );
};

const AddSubCategory = props => {
  const { classes } = props;
  const [caterrors, setCateErrors] = useState(null);
  const [isLoadingcat, setLoadingcat] = useState(false);
  const [categorieslist, setCategorieslist] = useState([]);
  let session = sessionStorage.getItem('user');
  let countryid = session ? `${JSON.parse(session).findAdmin.country_id}` : '';

  useEffect(() => {
    getcategorieslist(countryid).then(response => {
      setCategorieslist(
        response.data.ResponseData.getData === null
          ? ''
          : response.data.ResponseData.getData
      );
    });
  }, []);

  const [cate, setAddcate] = useState({
    categoryId: '',
    subCategoryName: ''
  });

  const handleChange = (key, e) => {
    setAddcate({
      ...cate,
      [key]: e.target.value
    });
  };

  const schemacate = [
    {
      field: 'categoryId',
      method: ['isEmpty'],
      validWhen: false,
      message: 'categoryName is required.'
    },
    {
      field: 'subCategoryName',
      method: ['isEmpty'],
      validWhen: false,
      message: 'subCategoryName is required.'
    }
  ];
  const validatorcate = new FormValidator(schemacate);
  const addcategorytosubcategory = () => {
    //console.log("cateDet");

    const err = validatorcate.validate({ ...cate });
    setCateErrors(err);
    if (!err.isValid) {
      return;
    }
    setLoadingcat(true);

    registersubcategory(cate, (message, isError) => {
      const catmethod = isError ? 'error' : 'success';
      toast[catmethod](message);
      setLoadingcat(false);
      setAddcate({
        categoryId: '',
        subCategoryName: ''
      });
      //window.location.reload();
    });
  };

  return (
    <div className={classes.category}>
      <Card className={classes.root}>
        <CardHeader
          subheader="Add Sub-Category"
          classes={{ subheader: classes.header }}
        />
        <CardContent>
          <FormControl className={classes.formControl}>
            <InputLabel shrink id="demo-simple-select-placeholder-label-label">
              Category
            </InputLabel>
            <Select
              labelId="demo-simple-select-placeholder-label-label"
              id="demo-simple-select-placeholder-label"
              name="categoryId"
              value={cate.categoryId}
              onChange={e => handleChange('categoryId', e)}
              displayEmpty
              classes={{ select: classes.inputRoot }}
              error={
                caterrors &&
                caterrors.categoryId &&
                caterrors.categoryId.isInvalid
              }
              helperText={
                caterrors &&
                caterrors.categoryId &&
                caterrors.categoryId.isInvalid &&
                caterrors.categoryId.message
              }
            >
              <MenuItem value="">
                <em>Select Category</em>
              </MenuItem>
              {categorieslist.map(option => (
                <MenuItem key={option.category_id} value={option.category_id}>
                  {option.category_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Sub-Category Name"
            placeholder="Add Sub-category name"
            name="subCategoryName"
            value={cate.subcategoryName}
            onChange={e => handleChange('subCategoryName', e)}
            error={
              caterrors &&
              caterrors.subCategoryName &&
              caterrors.subCategoryName.isInvalid
            }
            helperText={
              caterrors &&
              caterrors.subCategoryName &&
              caterrors.subCategoryName.isInvalid &&
              caterrors.subCategoryName.message
            }
          />
          <Button
            size="small"
            label="Add"
            onClick={addcategorytosubcategory}
          ></Button>
        </CardContent>
      </Card>
    </div>
  );
};

const CategoryWrapper = props => {
  const classes = props.classes;

  return (
    <div>
      <AddCategory classes={props.classes} />
      <AddSubCategory classes={props.classes} />
    </div>
  );
};

export default CategoryWrapper;
